import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import {ProductConsumer} from '../context';
import './ListedItems.css';


class ListedItems extends Component {
    render() {
        const {id, make, image, disc, price, inCart} = this.props.products;
        return (
            <ProductConsumer>
                {value=>(
                    <div className="mx-sm-1 mx-md-3 my-3">
                        <div className="card d-flex flex-row">
                            <div className="image mx-auto">
                                <div className="card-img-top" alt="...">
                                    <Link to='/product/detail' onClick={()=>value.handleDetail(id)}>
                                        <img src={image} alt=""/>
                                    </Link>
                                </div>
                            </div>
                            <div className="card-body">
                                <h5 className="card-title">{make}</h5>
                                <p className="card-text">
                                    {disc}
                                </p>
                                <div className="cardbottom d-flex flex-row">
                                    <div className="price d-flex ml-auto">
                                    <h5 className="">${price}.00</h5>
                                    </div>
                                    <div className="ml-2 mt-auto">
                                    <i class="fas fa-heart"></i>
                                        <button className="cart-btn" disabled={inCart ? true : false} onClick={()=>{console.log("added to the cart");}}>
                                            <i className="fas fa-shopping-cart" onClick={()=>{
                                            value.addToCart(id);
                                            }}/>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </ProductConsumer>
        );
    }
}

export default ListedItems;
